import React from 'react';
import { ActivityIcon, FlameIcon, ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_PRICE, formatPrice } from '../data/config';
import { offerItems } from '../data/content';
import { CheckItem } from './CheckItem';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type OfferSectionProps = {
  showReferencePrices: boolean;
  guaranteeEnabled: boolean;
};
export function OfferSection({
  guaranteeEnabled
}: OfferSectionProps) {
  return <section id="offer" className="scroll-mt-2 bg-white px-4 py-6 text-center md:px-12 md:py-8" data-id="element-135" data-mp="meju0a09wfrg">
      <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-amber-700 md:text-[12px]" data-id="element-136" data-mp="re67mkk0jy0s">
        Special launch offer
      </p>

      <div className="mx-auto mt-1.5 max-w-[512px] rounded-lg border-2 border-amber-400 bg-slate-50 px-3 pb-4 pt-3 md:px-4" data-id="element-137" data-mp="wbokun52czel">
        <h2 className="text-[22px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-blue-950 md:text-[28px]" data-id="element-138" data-mp="2t7dxup16001g">
          <ActivityIcon className="mr-1.5 inline h-6 w-6 -translate-y-0.5 text-teal-700" strokeWidth={2.5} aria-hidden data-id="element-139" data-mp="12niedon92hv2" />
          Complete Postoperative Shoulder Rehabilitation System™
        </h2>
        <p className="mx-auto mt-1 max-w-[420px] text-[11px] font-bold uppercase leading-[1.35] text-teal-700 md:text-[12px]" data-id="element-140" data-mp="sxp3kpuxm6rv">
          The complete collection of advanced resources for physical therapists treating patients after shoulder surgery.
        </p>

        <div className="mx-auto mt-2.5 max-w-[220px]" data-id="element-141" data-mp="1lll7aeix4yy5">
          <ProductImage data-id="element-142" data-mp="1gmroq7oryhr4" />
        </div>

        <p className="mt-2 text-[13px] font-extrabold uppercase text-blue-950 md:text-[14px]" data-id="element-143" data-mp="1gnt76x84e6iv">
          7 Advanced Clinical Volumes + 5 FREE Professional Bonuses
        </p>
        <p className="mt-0.5 text-[13px] text-slate-600 md:text-[14px]" data-id="element-144" data-mp="17ljvw551294f">Your purchase includes:</p>
        <ul className="mx-auto mt-1.5 max-w-[400px] text-left text-[14px] leading-[1.5] text-slate-600 md:text-[15px]" data-id="element-145" data-mp="17ki0nvfrdp2">
          {offerItems.map(item => <CheckItem key={item} data-id="element-146" data-mp="3ttzqk4ie86m3">{item}</CheckItem>)}
        </ul>
        <p className="mt-2 text-[12px] font-extrabold uppercase text-teal-700 md:text-[13px]" data-id="element-147" data-mp="3trwqssrfuz46">
          480 pages across 12 digital resources
        </p>

        <p className="mt-3 flex items-center justify-center gap-1.5 text-[14px] font-extrabold uppercase leading-tight text-blue-950 md:text-[16px]" data-id="element-148" data-mp="3ks9ps82mfvbn">
          <FlameIcon className="h-4 w-4 shrink-0 fill-orange-400 text-orange-600" strokeWidth={2} aria-hidden data-id="element-149" data-mp="3owr802tc20kb" />
          Get the complete system today!
        </p>
        <p className="mt-1 text-[14px] font-extrabold uppercase text-blue-950" data-id="element-150" data-mp="3fv00qtj59loc">Only</p>
        <p className="text-[46px] font-extrabold leading-none tracking-[-1px] text-amber-500 md:text-[54px]" data-id="element-151" data-mp="316dcu3fgblli">
          {formatPrice(PRODUCT_PRICE)} <span className="text-[18px] tracking-normal text-blue-950 md:text-[20px]" data-id="element-152" data-mp="362ca6gircdy2">USD</span>
        </p>

        <div className="mt-2.5" data-id="element-153" data-mp="2s703darbux0s">
          <CtaButton mode="checkout" className="max-w-none min-h-[64px]" data-id="element-154" data-mp="2x408njgcrvqu">
            Get instant access
          </CtaButton>
        </div>

        <p className="mx-auto mt-2.5 max-w-[420px] text-[11px] font-bold uppercase leading-snug text-blue-950 md:text-[12px]" data-id="element-155" data-mp="2di73v22as4ze">
          {guaranteeEnabled && <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-teal-700" aria-hidden data-id="element-156" data-mp="2mivfjq47xt94" />}
          Instant digital delivery
          {guaranteeEnabled && <>
              {' '}
              <span className="text-amber-500" data-id="element-157" data-mp="2wf8bkun8kj71">•</span> 7-day money-back guarantee
            </>}
        </p>
        <p className="mt-1 text-[12px] font-extrabold uppercase text-teal-700 md:text-[13px]" data-id="element-158" data-mp="2rflxyk3hx0xp">
          7 Advanced Volumes + 5 FREE Professional Bonuses
        </p>
      </div>
    </section>;
}